"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsplashUtil = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _JsUnsplashUtil2 = require("./JsUnsplashUtil");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UnsplashUtil = /*#__PURE__*/function (_JsUnsplashUtil) {
  (0, _inherits2.default)(UnsplashUtil, _JsUnsplashUtil);

  var _super = _createSuper(UnsplashUtil);

  function UnsplashUtil(functions) {
    (0, _classCallCheck2.default)(this, UnsplashUtil);
    return _super.call(this, functions);
  }
  /**
   * Inform Unsplash that the user intends to use the image
   * in a manner equivalent to a download as per the Unsplash API guidelines
   *
   * @param imageId The Unsplash ID of the image
   */


  (0, _createClass2.default)(UnsplashUtil, [{
    key: "download",
    value: function download(imageId) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(UnsplashUtil.prototype), "download", this).call(this, imageId);
    }
    /**
     * Search Unsplash for the provided search term.
     *
     * @param searchTerm The string to search for
     * @param page The page that the user requests as per paged search results
     */

  }, {
    key: "search",
    value: function search(searchTerm, page) {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(UnsplashUtil.prototype), "search", this).call(this, searchTerm, page);
    }
  }]);
  return UnsplashUtil;
}(_JsUnsplashUtil2.JsUnsplashUtil);

exports.UnsplashUtil = UnsplashUtil;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9kYW8vdW5zcGxhc2gvVW5zcGxhc2hVdGlsLnRzIl0sIm5hbWVzIjpbIlVuc3BsYXNoVXRpbCIsImZ1bmN0aW9ucyIsImltYWdlSWQiLCJzZWFyY2hUZXJtIiwicGFnZSIsIkpzVW5zcGxhc2hVdGlsIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFDQTs7Ozs7O0lBRWFBLFk7Ozs7O0FBRVQsd0JBQW1CQyxTQUFuQixFQUF5QztBQUFBO0FBQUEsNkJBQy9CQSxTQUQrQjtBQUV4QztBQUVEO0FBQ0o7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7V0FDSSxrQkFBZ0JDLE9BQWhCLEVBQXVDO0FBQ25DLDZHQUFlQSxPQUFmO0FBQ0g7QUFFRDtBQUNKO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7Ozs7V0FDSSxnQkFBY0MsVUFBZCxFQUFrQ0MsSUFBbEMsRUFBZ0Y7QUFDNUUsa0hBQW9CRCxVQUFwQixFQUFnQ0MsSUFBaEM7QUFDSDs7O0VBeEJ3Q0MsK0IiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge1Vuc3BsYXNoSXRlbSwgVW5zcGxhc2hTZWFyY2hSZXN1bHRzfSBmcm9tIFwiLi4vLi4vbW9kZWwvXCI7XG5pbXBvcnQge0pzVW5zcGxhc2hVdGlsfSBmcm9tICcuL0pzVW5zcGxhc2hVdGlsJ1xuXG5leHBvcnQgY2xhc3MgVW5zcGxhc2hVdGlsPEZVTkNUSU9OUz4gZXh0ZW5kcyBKc1Vuc3BsYXNoVXRpbCB7XG5cbiAgICBwdWJsaWMgY29uc3RydWN0b3IoZnVuY3Rpb25zOiBGVU5DVElPTlMpIHtcbiAgICAgICAgc3VwZXIoZnVuY3Rpb25zKVxuICAgIH1cblxuICAgIC8qKlxuICAgICAqIEluZm9ybSBVbnNwbGFzaCB0aGF0IHRoZSB1c2VyIGludGVuZHMgdG8gdXNlIHRoZSBpbWFnZVxuICAgICAqIGluIGEgbWFubmVyIGVxdWl2YWxlbnQgdG8gYSBkb3dubG9hZCBhcyBwZXIgdGhlIFVuc3BsYXNoIEFQSSBndWlkZWxpbmVzXG4gICAgICpcbiAgICAgKiBAcGFyYW0gaW1hZ2VJZCBUaGUgVW5zcGxhc2ggSUQgb2YgdGhlIGltYWdlXG4gICAgICovXG4gICAgcHVibGljIGRvd25sb2FkKGltYWdlSWQ6IHN0cmluZyk6IHZvaWQge1xuICAgICAgICBzdXBlci5kb3dubG9hZChpbWFnZUlkKVxuICAgIH1cblxuICAgIC8qKlxuICAgICAqIFNlYXJjaCBVbnNwbGFzaCBmb3IgdGhlIHByb3ZpZGVkIHNlYXJjaCB0ZXJtLlxuICAgICAqXG4gICAgICogQHBhcmFtIHNlYXJjaFRlcm0gVGhlIHN0cmluZyB0byBzZWFyY2ggZm9yXG4gICAgICogQHBhcmFtIHBhZ2UgVGhlIHBhZ2UgdGhhdCB0aGUgdXNlciByZXF1ZXN0cyBhcyBwZXIgcGFnZWQgc2VhcmNoIHJlc3VsdHNcbiAgICAgKi9cbiAgICBwdWJsaWMgc2VhcmNoKHNlYXJjaFRlcm06IHN0cmluZywgcGFnZTogbnVtYmVyKTogUHJvbWlzZTxVbnNwbGFzaFNlYXJjaFJlc3VsdHM+IHtcbiAgICAgICAgcmV0dXJuIHN1cGVyLnNlYXJjaChzZWFyY2hUZXJtLCBwYWdlKVxuICAgIH1cbn1cbiJdfQ==